import { Range } from '../../core/classes/range'

export interface Duration {
  days: number
  hours: number
  minutes: number
  seconds: number
}

export class DateRange extends Range<Date> {
  get isPassed(): boolean {
    const now = new Date()
    return Boolean(this.max && this.max < now)
  }

  get isComing(): boolean {
    const now = new Date()
    return Boolean(this.min && this.min > now)
  }

  get isCurrent(): boolean {
    return !this.isComing && !this.isPassed
  }

  get startsIn(): Duration & { exceeded: boolean } {
    return {
      exceeded: !this.isComing,
      ...this.durationBetween(new Date(), this.min),
    }
  }

  get endsIn(): Duration & { exceeded: boolean } {
    return {
      exceeded: this.isPassed,
      ...this.durationBetween(new Date(), this.max),
    }
  }

  get lastsFor(): Duration {
    return this.durationBetween(this.max, this.min)
  }

  protected override parse(value?: string): Date | undefined {
    return value ? new Date(value) : undefined
  }

  private durationBetween(start?: Date, end?: Date): Duration {
    if (!start || !end) {
      return {
        days: Infinity,
        hours: Infinity,
        minutes: Infinity,
        seconds: Infinity,
      }
    }

    const milliseconds = Math.abs(end.getTime() - start.getTime())

    const time = Math.round(milliseconds / 1000)
    const days = Math.trunc(time / 60 / 60 / 24)
    const daysRest = time % (60 * 60 * 24)

    const hours = Math.trunc(daysRest / 60 / 60)
    const hoursRest = daysRest % (60 * 60)

    const minutes = Math.trunc(hoursRest / 60)
    const seconds = hoursRest % 60

    return { days, hours, minutes, seconds }
  }
}
